'use strict';

const AncillariesTracking = require('./ancillaries_base');
const SUPPORT_PACK_PLANS_ENUM = new Odigeo.Enum(['basic', 'standard', 'premium']);
const LABEL_CATEGORIES = [
    'SO',
    AncillariesTracking.UNKNOWN_CLASSES_ENUM.UNKNOWN,
];
const BASIC_EVENT_ACTION = 'B';
const LABEL_CATEGORIES_ENUM = new Odigeo.Enum(LABEL_CATEGORIES);
const LABEL_CATEGORIES_BY_POLICY = {
    'S': LABEL_CATEGORIES_ENUM.SO,
    'P': LABEL_CATEGORIES_ENUM.SO,
    'B': LABEL_CATEGORIES_ENUM.SO,
    'STANDARD': LABEL_CATEGORIES_ENUM.SO,
    'PREMIUM': LABEL_CATEGORIES_ENUM.SO,
    'BASIC': LABEL_CATEGORIES_ENUM.SO,
};

const LABEL_EXPANDED_CATEGORIES_INTO_POLICIES = [
    'CANC',
    'CANCASS',
    'COMPREH',
    'ANYREASON',
    'FLEX',
    'ASS',
    'HUB',
    'LUG',
    'ESTA',
    'EVISA',
    'AUTO_CHECKIN',
    'CONFIRMATION_SMS',
    'BAGGAGE_ASSISTANCE',
    'DELAY',
    'BANKRUPTCY',
    'SO',
    AncillariesTracking.UNKNOWN_CLASSES_ENUM.UNKNOWN,
];

const EVENT_ACTIONS = [
    'ancillary_selection',
    'ancillary_information',
    'ancillary_onload',
    'nags',
];
const EVENT_ACTIONS_ENUM = new Odigeo.Enum(EVENT_ACTIONS);

const POLICY = AncillariesTracking.POLICY;
const CATEGORY = AncillariesTracking.CATEGORY;
const PAGE = AncillariesTracking.PAGE;

const EVENTS_DICTIONARY = {
    'onload': {
        'action': EVENT_ACTIONS_ENUM.ancillary_onload,
        'label': `ancillary_product_onload_pol:${POLICY}_pag:${PAGE}`,
    },
    'add': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_add_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'remove': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_remove_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'open_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_open_details_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'close_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_close_details_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'add_from_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_details_add_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'modify': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_product_modify_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'change_phone': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `change_phone_unfolded_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'change_phone_ok': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `change_phone_done_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'change_phone_incorrect': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `change_phone_incorrectnumber_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'continue': {
        'action': EVENT_ACTIONS_ENUM.ancillary_selection,
        'label': `ancillary_product_selected_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'continue_without_so_error': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_error_message_cat:none_pol:0_pag:${PAGE}`,
    },
    'evo_open_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_see_more_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'evo_close_details': {
        'action': EVENT_ACTIONS_ENUM.ancillary_information,
        'label': `ancillary_see_less_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}`,
    },
    'nag': {
        reject: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_reject_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_reject_add`,
            },
            reject: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_reject_continue`,
            },
        },
        continuance: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_add`,
            },
            reject: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_continue`,
            },
            tryclose: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_submit_tryclose`,
            },
        },
        confirmation: {
            appears: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_confirmation_appearances`,
            },
            accept: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_confirmation_add`,
            },
            reject: {
                action: EVENT_ACTIONS_ENUM.nags,
                label: `nag_cat:${CATEGORY}_pol:${POLICY}_pag:${PAGE}_confirmation_continue`,
            },
        },
    },
};
const TRACKING_PAGES = {
    desktop: {
        payment: 'ancillaries',
    },
    mobile: {
        servicepack: 'servicepack',
    },
};

const formatServiceOptionsParam = (param) => {
    const normalizedParam = Odigeo._.isString(param) ? param.toLowerCase() : param;
    let eventAction;
    if (!Odigeo._.isEmpty(SUPPORT_PACK_PLANS_ENUM[normalizedParam])) {
        switch (normalizedParam) {
            case SUPPORT_PACK_PLANS_ENUM.basic:
                eventAction = BASIC_EVENT_ACTION;
                break;
            default :
                eventAction = param[0].toUpperCase();
                break;
        }
    } else {
        eventAction = param;
    }

    return eventAction;
};

class AncillariesTrackingSupportPack extends AncillariesTracking {
    constructor(product) {
        super(
            product,
            EVENTS_DICTIONARY,
            LABEL_CATEGORIES,
            LABEL_CATEGORIES_BY_POLICY,
            TRACKING_PAGES,
            {},
            LABEL_EXPANDED_CATEGORIES_INTO_POLICIES
        );
    }

    getTrackData(type, param, pageName) {
        param = formatServiceOptionsParam(param);
        return super.getTrackData(type, param, pageName);
    }
}

AncillariesTrackingSupportPack.prototype.modifySelection = AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('modify');
AncillariesTrackingSupportPack.prototype.changePhoneNumber = AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('change_phone');
AncillariesTrackingSupportPack.prototype.changePhoneNumberOk = AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('change_phone_ok');
AncillariesTrackingSupportPack.prototype.changePhoneIncorrect =
    AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('change_phone_incorrect');
AncillariesTrackingSupportPack.prototype.continueWithoutSoError =
    AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('continue_without_so_error');
AncillariesTrackingSupportPack.prototype.nagRejectAppears = AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('nag.reject.appears');
AncillariesTrackingSupportPack.prototype.nagRejectAccept = AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('nag.reject.accept');
AncillariesTrackingSupportPack.prototype.nagRejectReject = AncillariesTrackingSupportPack.prototype.prepareTrackEventFunction('nag.reject.reject');

module.exports = AncillariesTrackingSupportPack;
